import React, { useContext } from 'react'
import { BlockLink, Text, Button } from 'pcln-design-system'
import analytics from '../../utils/analytics'
import { InventoryWrapper } from './Common'
import { ANALYTICS_CATEGORY_HOME } from '../../constants/analytics'
import BootstrapDataContext from '../../context/BootstrapDataContext'

export default function NoInventoryFallback({
  xSellMessaging,
  xSellTarget,
  xSellUrl,
  xSellProduct,
  offerNum
}: {
  xSellMessaging: string
  xSellTarget: 'Rental Cars' | 'Hotels' | 'Flights'
  xSellUrl: string
  xSellProduct: 'hotel' | 'flight' | 'car'
  offerNum: string
}) {
  const { webstats, customer } = useContext(BootstrapDataContext)

  return (
    <InventoryWrapper
      data-product={xSellTarget}
      data-label={`Search ${xSellTarget}`}
      data-parent-product={xSellProduct}
      data-source="homepage"
      data-sub-type="cross sell"
      data-has-inventory={false}
      data-cguid={webstats.clientGUID}
      data-email-address={customer.emailAddress}
      data-parent-offer={offerNum}
      data-rudder-event
    >
      <Text
        color="primary"
        fontSize={3}
        fontWeight="bold"
        mb="24px"
        lineHeight="24px"
      >
        {xSellMessaging}
      </Text>
      <BlockLink
        onClick={() => {
          analytics.fireEvent({
            action: 'Feature Box CTA',
            category: ANALYTICS_CATEGORY_HOME,
            label: 'Cross Sell Search Button'
          })
        }}
        href={xSellUrl}
        target="_new"
      >
        <Button data-testid="XSELL_SEARCH_BUTTON" size="large">
          Search {xSellTarget}
        </Button>
      </BlockLink>
    </InventoryWrapper>
  )
}
